const state = {

}

const mutations = {

}

const actions = {
  updateMonitorDia() {
    window.axios.get('/api/v2/monitores/atualizar')
  }
}

export default {
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/Monitores.js